import React from 'react';
import GameScreen from './GameScreen/GameScreen';

/**
 * Legacy `/game-results` route — redirects to GameScreen which handles the
 * `final` phase via its internal state machine (subscribed to `game_ended`).
 */
export default function GameResultsScreen() {
  return <GameScreen />;
}
